<template>
    <div class="app-container mt-5">

        <div class="page-title mb-3">
            <router-link to="/configuration">
                <span class="breadcrumb-link">
                    <v-icon class="breadcrumb-link-icon">settings</v-icon> Configuration du compte
                </span>
            </router-link>
            <v-icon>keyboard_arrow_right</v-icon>
            <span class="breadcrumb-item">
                <v-icon class="breadcrumb-item-icon">bookmarks</v-icon> Mes tags
            </span>
        </div>

        <div class="row">
            <div class="col-3">
                <v-alert text class="mb-5">
                    Gérez ici vos tags associés à vos prestataires. Vous pouvez en <b>ajouter / supprimer</b> et
                    aussi
                    les <b>renommer</b>. <br>Vous pouvez aussi <b>visualiser</b> les fiches associées à vos tags.
                </v-alert>

                <v-alert type="info" text class="mb-5" v-if="untagged > 0">
                    <p>Certaines de vos fiches ne sont pas taggées</p>
                    <v-btn outlined color="primary" @click="filterUntaggedProvider">
                        Voir mes {{ untagged }} fiches
                    </v-btn>
                </v-alert>
            </div>
            <div class="col">
                <v-card class="p-4">
                    <div class="d-flex mb-5">
                        <v-btn outlined class="custom-button-primary" @click="addModal = true">
                            <v-icon left>add</v-icon> Ajouter un tag
                        </v-btn>
                    </div>

                    <div v-if="tags.length">
                        <v-data-table :headers="headers" :items="tags" :loading="loading" class="border" :footer-props="{
                            itemsPerPageAllText: 'Toutes',
                            itemsPerPageText: 'Tags par page',
                            itemsPerPageOptions: [10, 20, 50, 100]
                        }">
                            <template v-slot:item.name="{ item }">
                                <a @click="prepareOpenEditModal(item)">{{ item.name }}</a>
                            </template>
                            <template v-slot:item.providers_count="{ item }">
                                <v-btn text color="primary" @click="filterBygTag(item)">
                                    {{ item.providers_count }}
                                </v-btn>
                            </template>
                            <template v-slot:item.actions="{ item }">
                                <v-btn small icon color="error" @click="deleteTag(item)">
                                    <v-icon>delete</v-icon>
                                </v-btn>
                            </template>
                        </v-data-table>
                    </div>

                    <div v-else class="text-center">
                        <small>Aucun tag n'a été ajouté pour le moment</small>
                    </div>

                </v-card>
            </div>
        </div>

        <v-dialog v-model="editModal" persistent max-width="600px">
            <v-card v-if="selectedTag !== null">
                <v-card-title>
                    <span class="headline">Modification d'un tag</span>
                </v-card-title>

                <v-card-text>
                    <v-text-field background-color="white" label="Nom" v-model="selectedTag.name" outlined>
                    </v-text-field>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <div class="w-100 text-left mb-4 ml-4">
                        <v-btn color="error" @click="editModal = false">Annuler</v-btn>
                    </div>

                    <div class="w-100 text-right mb-4 mr-4">
                        <v-btn color="primary" @click="updateTag"
                            :disabled="selectedTag.name === null || selectedTag.name === ''">Enregister</v-btn>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="addModal" persistent max-width="600px">
            <v-card>
                <v-card-title>
                    <span class="headline">Ajout d'un tag</span>
                </v-card-title>

                <v-card-text>
                    <v-text-field background-color="white" label="Nom" v-model="tagName" outlined>
                    </v-text-field>

                    <div class="d-flex justify-content-end gap-10">
                        <v-btn @click="addModal = false">Annuler</v-btn>
                        <v-btn class="default-button custom-button-primary" @click="addTag"
                            :disabled="tagName === null || tagName === ''">Ajouter
                        </v-btn>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>

        <confirm ref="confirm"></confirm>
    </div>
</template>

<script>
import { mapMutations, mapState } from "vuex"
import Confirm from "../../tools/Confirm"

export default {
    name: "TagConfig",
    components: { Confirm },
    data() {
        return {
            loading: false,
            tags: [],
            untagged: 0,
            editModal: false,
            addModal: false,
            tagName: null,
            headers: [
                {
                    text: 'Nom',
                    value: 'name'
                },
                {
                    text: 'Fiches associées',
                    value: 'providers_count'
                },
                {
                    text: '',
                    value: 'actions'
                },
            ],
            selectedTag: null
        }
    },
    methods: {
        ...mapMutations('providerFilter', [
            'setSelectedTags',
            'setSelectedWebFormStates',
            'setSelectedCategories',
            'setSelectedCommunes',
            'setSearch'

        ]),
        getTags() {
            this.$http.get('auth/account/tag-stats').then(res => {
                this.tags = res.body.data.tags
                this.untagged = res.body.data.withoutTags
            })
        },
        filterBygTag(tag) {
            this.setSelectedTags([tag.id])
            this.setSelectedWebFormStates([])
            this.setSelectedCommunes([])
            this.setSelectedCategories([])
            this.setSearch(null)

            this.$router.push('/providers')
        },
        prepareOpenEditModal(tag) {
            this.selectedTag = JSON.parse(JSON.stringify(tag))
            this.editModal = true
        },
        updateTag() {
            let payload = {
                id: this.selectedTag.id,
                name: this.selectedTag.name
            }

            this.$global.loading = true

            this.$http.post('auth/account/tag/update', payload).then(res => {
                this.getTags()

                this.$store.dispatch('account/fetchTags')

                this.$global.loading = false

                this.editModal = false
            })
        },
        addTag() {
            let payload = {
                name: this.tagName
            }

            this.$global.loading = true

            this.$http.post('auth/account/tag/add', payload).then(res => {
                this.getTags()

                this.$store.dispatch('account/fetchTags')

                this.$global.loading = false

                this.tagName = null
                this.addModal = false
            })
        },
        deleteTag(tag) {
            this.$refs.confirm.open('Attention',
                'Vous allez supprimer le tag <b>' + tag.name,
                { color: 'red' }).
                then((confirm) => {
                    if (confirm) {
                        this.$global.loading = true

                        this.$http.delete('auth/account/tag/' + tag.id).then(res => {
                            this.getTags()

                            this.$store.dispatch('account/fetchTags')

                            this.$global.loading = false
                        })
                    }
                })
        },
        filterUntaggedProvider() {
            this.setSelectedTags([])
            this.setSelectedWebFormStates(['WITHOUT_TAG'])
            this.setSelectedCommunes([])
            this.setSelectedCategories([])
            this.setSearch(null)

            this.$router.push('/providers')
        }
    },
    computed: {
        ...mapState('account', ['account', 'user'])
    },
    created() {
        this.getTags()
    }
}
</script>